/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostTag {
    getFixupPrototypeFunction() { return CostTag.fixupPrototype; }

    static newInstance(model: Partial<CostTag>): CostTag {
        let obj = Object.assign(new CostTag(), model);
        CostTag.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostTag>): CostTag {
        if (!model) return null;
        return CostTag.newInstance(<CostTag> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostTag) {
        if (!obj) return;

        models.CostTag.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostTag): boolean {
        Object.setPrototypeOf(obj, CostTag.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Tag key
     */
    key: string;

    /**
     * Values for the tag key
     */
    values: Array<string>;

}
